<div class="ui-widget-home ui-icon-loading-container">
   <div class="loginLoadingTextForWaiting">{{'dialog_waiting_text' | i18nv2}}</div>
   <loading-image-animation [showLoading]="true"></loading-image-animation>
</div>